module.exports = __webpack_public_path__ + "static/media/tanqueMSPTNvert.a1585c13.jpg";